import { Col, Form, Row } from "react-bootstrap";
import {
  IDescricaoProcessoFinanceiro,
  IFornecedorPF,
  IFornecedorPJ,
} from "../../interfaces/IFornecedor";
import { StatusFornecedor } from "../StatusFornecedor";
import {
  Button,
  ContainerBtnFormProcessoFinanceiro,
  ContainerBtnSubmit,
  ContainerCinza,
  ContainerFormProcessoFinanceiro,
  ContainerStatus,
  ContainerTitle,
  IconeAdicionar,
  InputCheckboxContainer,
  RadioContainer,
  Title,
  TituloCampoProcessoFinanceiro,
} from "./style";
import { useEffect, useMemo, useState } from "react";
import { CustomInput } from "components/CustomInput";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { acaoFornecedorSchema } from "../../validate/validator";
import { Required } from "components/Required";
import {
  FaArrowLeft,
  FaCheck,
  FaCopy,
  FaPen,
  FaPlus,
  FaTimes,
} from "react-icons/fa";
import { toastErro, toastSucesso } from "components/Toast";
import { IColum } from "containers/Table/interfaces";
import { Table } from "containers/Table";
import { DropdownSelect, IOptions } from "components/DropdownSelect";
import { useMaskInput } from "hooks/useMaskInput";
import { ModalConfirmarExcluirProcessoFinanceiro } from "../ModalConfirmarExcluirProcessoFinanceiro";
import { HttpError } from "_services/api/HttpError";
import { IData } from "_services/api/interface/HttpResponse";
import { HttpResponse } from "_services/api/HttpResponse";
import { ModalConfirmarEditarFornecedor } from "../ModalConfirmarEditarFornecedor";
import { ModalConfirmarCancelarEditarFornecedor } from "../ModalConfirmarCancelarEditarFornecedor";
import { IFiltro } from "../../interfaces/IFiltro";
import { formatarDinheiro } from "_utils/Money";
import { OptionsBancos } from "features/core/pages/Financeiro/Constants/OptionsBancos";
import { useCep } from "hooks/useCep";
import { ehCnpj } from "_utils/validarCpfCnpj";
import usePermissoes from "hooks/usePermissoes";

interface IProps {
  dados: IFornecedorPF | IFornecedorPJ | null;
  acaoFornecedor: "VER" | "ATUALIZAR" | "LISTAR" | "CADASTRAR";
  setAcaoFornecedor: (
    acaoFornecedor: "VER" | "ATUALIZAR" | "LISTAR" | "CADASTRAR"
  ) => void;
  optionsDescricaoProcessoFinanceiro: IOptions[];
  inserirFornecedor: (
    dados: IFornecedorPF | IFornecedorPJ
  ) => Promise<HttpError<IData, any> | HttpResponse<any, any>>;
  atualizarFornecedor: (
    id: number,
    dados: IFornecedorPF | IFornecedorPJ
  ) => Promise<HttpError<IData, any> | HttpResponse<any, any>>;
  listar: (dados: IFiltro) => void;
  filtro: IFiltro;
  inserirDescricaoProcessoFinanceiroFornecedor: (
    id: number,
    dados: IDescricaoProcessoFinanceiro
  ) => Promise<HttpError<IData, any> | HttpResponse<any, any>>;
  atualizarDescricaoProcessoFinanceiroFornecedor: (
    id: number,
    idDescricaoProcessoFinanceiroFornecedor: number,
    dados: IDescricaoProcessoFinanceiro
  ) => Promise<HttpError<IData, any> | HttpResponse<any, any>>;
  excluirDescricaoProcessoFinanceiroFornecedor: (
    id: number,
    idDescricaoProcessoFinanceiroFornecedor: number
  ) => Promise<HttpError<IData, any> | HttpResponse<any, any>>;
  setLoading: (loading: boolean) => void;
}
export function FormAcaoFornecedor({
  dados,
  acaoFornecedor,
  setAcaoFornecedor,
  optionsDescricaoProcessoFinanceiro,
  inserirFornecedor,
  atualizarFornecedor,
  listar,
  filtro,
  inserirDescricaoProcessoFinanceiroFornecedor,
  atualizarDescricaoProcessoFinanceiroFornecedor,
  excluirDescricaoProcessoFinanceiroFornecedor,
  setLoading,
}: IProps) {
  const { temPermissao } = usePermissoes();
  const showBtnEditar = temPermissao("editar_fornecedores");

  const [tipoPessoa, setTipoPessoa] = useState<"juridica" | "fisica">(
    dados?.cpfCnpj && !ehCnpj(dados.cpfCnpj)
      ? "fisica"
      : "juridica"
  );
  const [showDadosPix, setShowDadosPix] = useState<boolean>(!!dados?.chavePix);
  const [showDadosTransferencia, setShowDadosTransferencia] = useState<boolean>(
    !!dados?.titularContaTransferencia
  );
  const [boletoChecked, setBoletoChecked] = useState<boolean>(
    dados?.boleto === "SIM"
  );
  const handleCheck = (tipo: "juridica" | "fisica") => {
    setTipoPessoa(tipo);
  };
  const [
    descricaoProcessoFinanceiroEscolhido,
    setDescricaoProcessoFinanceiroEscolhido,
  ] = useState<number | undefined>(undefined);
  const [
    valorProcessoFinanceiroEscolhido,
    setValorProcessoFinanceiroEscolhido,
  ] = useState<number | "">("");

  const {
    mInputCEP,
    mInputCPFCNPJ,
    mInputCNPJ,
    mInputCPF,
    mInputNum,
    mInputCoin,
    mInputTel,
  } = useMaskInput();

  const [dadosTabelaProcessoFinanceiro, setDadosTabelaProcessoFinanceiro] =
    useState<IDescricaoProcessoFinanceiro[]>(
      dados?.descricoesProcessoFinanceiro ?? []
    );
  const [acaoFormProcessoFinanceiro, setAcaoFormProcessoFinanceiro] = useState<
    "Adicionar" | "Atualizar"
  >("Adicionar");
  const [showModalConfirmarExclusao, setShowModalConfirmarExclusao] =
    useState<boolean>(false);
  const [
    idDescricaoProcessoFinanceiroExcluir,
    setIdDescricaoProcessoFinanceiroExcluir,
  ] = useState<number>(0);
  const [showModalConfirmarEditar, setShowModalConfirmarEditar] =
    useState<boolean>(false);
  const [dadosEditarFornecedor, setDadosEditarFornecedor] = useState<
    IFornecedorPF | IFornecedorPJ | null
  >(null);
  const [showModalCancelarEditar, setShowModalCancelarEditar] =
    useState<boolean>(false);

  const schema = useMemo(() => {
    return acaoFornecedorSchema(
      tipoPessoa,
      showDadosPix,
      showDadosTransferencia
    );
  }, [tipoPessoa, showDadosPix, showDadosTransferencia]);

  const {
    register,
    setValue,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    reset(getValues());
  }, [schema]);

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "responsaveis",
  });

  const novoCampo = () => {
    append({ nomeResponsavel: "", telefone: "", email: "" });
  };

  const resetarResponsaveis = () => {
    replace([{ nomeResponsavel: "", telefone: "", email: "" }]);
  };

  useEffect(() => {
    if (dados && acaoFornecedor !== "CADASTRAR") {
      setValue("cpfCnpj", dados.cpfCnpj ?? "");
      setValue("nomeRazaoSocial", dados.nomeRazaoSocial ?? "");
      setValue(
        "nomeFantasia",
        dados && "nomeFantasia" in dados ? dados?.nomeFantasia : ""
      );
      setValue("status", dados.status ?? "");
      setValue("cep", dados.cep ?? "");
      setValue("endereco", dados.endereco ?? "");
      setValue("numero", dados.numero ?? "");
      setValue("bairro", dados.bairro ?? "");
      setValue("cidade", dados.cidade ?? "");
      setValue("uf", dados.uf ?? "");
      setValue("complemento", dados.complemento ?? "");
      setValue("chavePix", dados.chavePix ?? "");
      setValue("titularContaPix", dados.titularContaPix ?? "");
      setValue("banco", dados.banco ? `${dados.banco}` : "");
      setValue("agencia", dados.agencia ?? "");
      setValue("conta", dados.conta ?? "");
      setValue(
        "titularContaTransferencia",
        dados.titularContaTransferencia ?? ""
      );
      setValue(
        "cpfCnpjTitularContaTransferencia",
        dados.cpfCnpjTitularContaTransferencia ?? ""
      );
      setValue("email", dados && "email" in dados ? dados?.email : "");
      setValue("telefone", dados && "telefone" in dados ? dados?.telefone : "");

      if (
        dados &&
        "responsaveis" in dados &&
        Array.isArray(dados?.responsaveis)
      ) {
        replace(dados.responsaveis);
      }
      return;
    }

    resetarResponsaveis();
  }, []);

  const handleCheckPix = (checked: boolean) => {
    setShowDadosPix(checked);
  };

  const handleCheckTransferencia = (checked: boolean) => {
    setShowDadosTransferencia(checked);
  };
  const handleCheckBoleto = (checked: boolean) => {
    setBoletoChecked(checked);
  };

  const onClickCopiarString = () => {
    if (!dados || !dados?.chavePix) {
      return;
    }

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(dados?.chavePix)
        .then(() => {
          toastSucesso("Copiado para área de transferência!");
        })
        .catch((error) => {
          toastErro("Falha ao copiar");
        });
      return;
    }
    toastErro(
      "Funcionalidade indisponível devido a configurações do navegador"
    );
  };

  const handleEditarProcessoFinanceiro = (
    idDescricaoProcessoFinanceiro: number
  ) => {
    const processoEscolhido = dadosTabelaProcessoFinanceiro.findLast(
      (linha) =>
        linha.idDescricaoProcessoFinanceiro == idDescricaoProcessoFinanceiro
    );

    if (processoEscolhido) {
      setDescricaoProcessoFinanceiroEscolhido(
        processoEscolhido.idDescricaoProcessoFinanceiro
      );
      setValorProcessoFinanceiroEscolhido(processoEscolhido.valor);
      setAcaoFormProcessoFinanceiro("Atualizar");
    }
  };

  const handleExcluirProcessoFinanceiroDoFornecedor = (
    idDescricaoProcessoFinanceiro: number
  ) => {
    setIdDescricaoProcessoFinanceiroExcluir(idDescricaoProcessoFinanceiro);
    setShowModalConfirmarExclusao(true);
  };

  const columnsProcessoFinanceiro: IColum<IDescricaoProcessoFinanceiro>[] = [
    {
      name: <span>ID</span>,
      selector: (item: IDescricaoProcessoFinanceiro) => item.id,
      width: "90px",
      omit: true,
    },

    {
      name: <span>Descrição processo financeiro</span>,
      selector: (item: IDescricaoProcessoFinanceiro) => item.descricao,
    },
    {
      name: <span>Valor por processo</span>,
      selector: (item: IDescricaoProcessoFinanceiro) =>
        item.valor ? formatarDinheiro(Number(item.valor)) : "--",
    },
    {
      name: <span>Ações</span>,
      selector: (item: IDescricaoProcessoFinanceiro) => (
        <span style={{ display: "flex", alignItems: "center" }}>
          <FaPen
            onClick={
              acaoFornecedor === "VER"
                ? () => {}
                : () =>
                    handleEditarProcessoFinanceiro(
                      item.idDescricaoProcessoFinanceiro
                    )
            }
            style={{
              marginRight: "24px",
              cursor: acaoFornecedor === "VER" ? "default" : "pointer",
              color: acaoFornecedor === "VER" ? "#999999" : "#000",
            }}
            title="Editar"
          />
          <FaTimes
            onClick={
              acaoFornecedor === "VER"
                ? () => {}
                : () =>
                    handleExcluirProcessoFinanceiroDoFornecedor(
                      item.idDescricaoProcessoFinanceiro
                    )
            }
            style={{
              marginRight: "24px",
              cursor: acaoFornecedor === "VER" ? "default" : "pointer",
              color: acaoFornecedor === "VER" ? "#FFCCD1" : "red",
            }}
            title="Excluir"
          />
        </span>
      ),
      width: "140px",
    },
  ];

  const handleLimparFormProcessoFinanceiro = () => {
    setDescricaoProcessoFinanceiroEscolhido(undefined);
    setValorProcessoFinanceiroEscolhido("");
    setAcaoFormProcessoFinanceiro("Adicionar");
  };

  const handleVoltarListagem = () => {
    setValue("cpfCnpj", "");
    setValue("nomeRazaoSocial", "");
    setValue("nomeFantasia", "");
    setValue("status", "");
    setValue("cep", "");
    setValue("endereco", "");
    setValue("numero", "");
    setValue("bairro", "");
    setValue("cidade", "");
    setValue("uf", "");
    setValue("complemento", "");
    setValue("chavePix", "");
    setValue("titularContaPix", "");
    setValue("banco", "");
    setValue("agencia", "");
    setValue("conta", "");
    setValue("titularContaTransferencia", "");
    setValue("cpfCnpjTitularContaTransferencia", "");

    setDadosTabelaProcessoFinanceiro([]);
    handleLimparFormProcessoFinanceiro();
    setTipoPessoa("juridica");
    setAcaoFornecedor("LISTAR");
  };

  const onSubmit = async (dadosForm: any) => {
    if (!showDadosPix && !showDadosTransferencia && !boletoChecked) {
      toastErro(
        "Alguma forma de pagamento deve ser escolhida nos dados bancários"
      );
      return;
    }

    if (!dadosForm) {
      return;
    }

    if (acaoFornecedor === "ATUALIZAR") {
      if (!dados) {
        return;
      }

      setDadosEditarFornecedor({
        ...dadosForm,
        boleto: boletoChecked ? "SIM" : "NAO",
        status: dados.status,
      });
      setShowModalConfirmarEditar(true);
      return;
    }

    if (!showDadosPix) {
      delete dadosForm.titularContaPix;
      delete dadosForm.chavePix;
    }

    if (!showDadosTransferencia) {
      delete dadosForm.cpfCnpjTitularContaTransferencia;
      delete dadosForm.banco;
      delete dadosForm.agencia;
      delete dadosForm.conta;
      delete dadosForm.titularContaTransferencia;
    }

    if (acaoFornecedor === "CADASTRAR") {
      if (
        !dadosTabelaProcessoFinanceiro ||
        !dadosTabelaProcessoFinanceiro.length
      ) {
        toastErro("É necessário cadastrar algum serviço para o fornecedor");
        return;
      }

      const { hasErro } = await inserirFornecedor({
        ...dadosForm,
        status: "ATIVO",
        boleto: boletoChecked ? "SIM" : "NAO",
        descricoesProcessoFinanceiro: dadosTabelaProcessoFinanceiro,
      });

      if (!hasErro) {
        toastSucesso("Fornecedor cadastrado com sucesso!");
        handleVoltarListagem();
        listar(filtro);
      }
      return;
    }
  };

  const confirmarEditarFornecedor = async () => {
    if (!dados || !dadosEditarFornecedor) {
      return;
    }
    const { hasErro } = await atualizarFornecedor(
      dados.id,
      dadosEditarFornecedor
    );

    if (!hasErro) {
      setDadosEditarFornecedor(null);
      toastSucesso("Alterações salvas com sucesso!");
      handleVoltarListagem();
      listar(filtro);
    }
  };

  const handleConfirmEditarFinanceiro = async () => {
    const processoEscolhido = dadosTabelaProcessoFinanceiro.findLast(
      (dado) =>
        dado.idDescricaoProcessoFinanceiro ==
        descricaoProcessoFinanceiroEscolhido
    );

    const opcaoEscolhida = optionsDescricaoProcessoFinanceiro.findLast(
      (option) => option.value == descricaoProcessoFinanceiroEscolhido
    );

    if (
      !processoEscolhido ||
      !opcaoEscolhida ||
      !valorProcessoFinanceiroEscolhido ||
      !descricaoProcessoFinanceiroEscolhido
    ) {
      toastErro("Não foi possível editar serviço.");
      return;
    }

    if (acaoFornecedor === "ATUALIZAR" && processoEscolhido?.id) {
      if (!dados?.id) {
        toastErro("Não foi possível editar este serviço.");
        return;
      }

      const { hasErro } = await atualizarDescricaoProcessoFinanceiroFornecedor(
        dados?.id,
        processoEscolhido.id,
        {
          valor: valorProcessoFinanceiroEscolhido,
          descricao: opcaoEscolhida.label,
          idDescricaoProcessoFinanceiro: descricaoProcessoFinanceiroEscolhido,
          idFornecedor: dados?.id,
        }
      );

      if (hasErro) {
        return;
      }

      toastSucesso("Edição salva com sucesso!");
    }

    setDadosTabelaProcessoFinanceiro(
      dadosTabelaProcessoFinanceiro.map((dado) => {
        if (
          dado.idDescricaoProcessoFinanceiro ==
            descricaoProcessoFinanceiroEscolhido &&
          valorProcessoFinanceiroEscolhido
        ) {
          if (
            opcaoEscolhida &&
            dado.idDescricaoProcessoFinanceiro == opcaoEscolhida.value
          ) {
            dado.descricao = opcaoEscolhida.label;
            dado.idDescricaoProcessoFinanceiro = Number(opcaoEscolhida.value);
            dado.valor = valorProcessoFinanceiroEscolhido;
          }
        }

        return dado;
      })
    );

    handleLimparFormProcessoFinanceiro();
  };

  const handleConfirmAdicionarFinanceiro = async () => {
    if (
      dadosTabelaProcessoFinanceiro.some(
        (dado) =>
          dado.idDescricaoProcessoFinanceiro ==
          descricaoProcessoFinanceiroEscolhido
      )
    ) {
      toastErro("Este serviço já foi escolhido para o fornecedor.");
      return;
    }

    const optionEscolhido = optionsDescricaoProcessoFinanceiro.findLast(
      (option) => option.value == descricaoProcessoFinanceiroEscolhido
    );

    if (
      !descricaoProcessoFinanceiroEscolhido ||
      !valorProcessoFinanceiroEscolhido ||
      !optionEscolhido
    ) {
      toastErro("Não foi possível cadastrar o serviço.");
      return;
    }

    if (acaoFornecedor === "ATUALIZAR") {
      if (!dados?.id) {
        toastErro("Não foi possível cadastrar o serviço.");
        return;
      }

      const { hasErro } = await inserirDescricaoProcessoFinanceiroFornecedor(
        dados?.id,
        {
          valor: valorProcessoFinanceiroEscolhido,
          descricao: optionEscolhido.label,
          idDescricaoProcessoFinanceiro: descricaoProcessoFinanceiroEscolhido,
          idFornecedor: dados?.id,
        }
      );

      if (hasErro) {
        return;
      }

      toastSucesso("Serviço salvo com sucesso!");
    }

    setDadosTabelaProcessoFinanceiro([
      ...dadosTabelaProcessoFinanceiro,
      {
        idDescricaoProcessoFinanceiro: descricaoProcessoFinanceiroEscolhido,
        valor: valorProcessoFinanceiroEscolhido,
        descricao: optionEscolhido.label,
      },
    ]);

    handleLimparFormProcessoFinanceiro();
  };

  const handleConfirmExcluirFinanceiro = async () => {
    if (!idDescricaoProcessoFinanceiroExcluir) {
      toastErro("Não foi possível excluir o serviço.");
      return;
    }

    const processoEscolhido = dadosTabelaProcessoFinanceiro.findLast(
      (dado) =>
        dado.idDescricaoProcessoFinanceiro ==
        idDescricaoProcessoFinanceiroExcluir
    );

    if (acaoFornecedor === "ATUALIZAR" && processoEscolhido?.id) {
      if (!dados?.id) {
        toastErro("Não foi possível excluir este serviço.");
        return;
      }

      const { hasErro } = await excluirDescricaoProcessoFinanceiroFornecedor(
        dados?.id,
        processoEscolhido?.id
      );

      if (hasErro) {
        return;
      }

      toastSucesso("Serviço excluído!");
    }

    setDadosTabelaProcessoFinanceiro(
      dadosTabelaProcessoFinanceiro.filter(
        (item) =>
          item.idDescricaoProcessoFinanceiro !==
          idDescricaoProcessoFinanceiroExcluir
      )
    );

    handleLimparFormProcessoFinanceiro();
    setIdDescricaoProcessoFinanceiroExcluir(0);
    setShowModalConfirmarExclusao(false);
  };

  const { obterDadosCepV2, dadosLocal } = useCep();
  const onChangeCep = async (element: any) => {
    mInputCEP(element);
    let cep = element.target.value;
    const qtdCarateresCep = 9;
    if (cep.length < qtdCarateresCep) {
      return;
    }
    setLoading(true);
    await obterDadosCepV2(cep);
    setLoading(false);
  };

  useEffect(() => {
    if (!dadosLocal) {
      return;
    }
    if (dadosLocal.logradouro) {
      setValue("endereco", dadosLocal.logradouro);
    }

    if (dadosLocal.localidade) {
      setValue("cidade", dadosLocal.localidade);
    }
    if (dadosLocal.uf) {
      setValue("uf", dadosLocal.uf);
    }
    if (dadosLocal.bairro) {
      setValue("bairro", dadosLocal.bairro);
    }
  }, [dadosLocal, setValue]);

  return (
    <>
      <Form
        noValidate={acaoFornecedor === "VER"}
        onSubmit={handleSubmit((dados) => {
          onSubmit(dados);
        })}
      >
        <ContainerCinza>
          <ContainerTitle style={{ marginBottom: "24px" }}>
            <Title>Dados cadastrais</Title>
            {!!dados && (
              <ContainerStatus>
                <Title>Status:</Title>{" "}
                {<StatusFornecedor width="100px" status={dados.status} />}
              </ContainerStatus>
            )}
          </ContainerTitle>
          <RadioContainer style={{ marginBottom: "24px" }}>
            <span
              onClick={
                acaoFornecedor === "CADASTRAR"
                  ? () => handleCheck("juridica")
                  : () => {}
              }
              style={
                acaoFornecedor === "CADASTRAR" ? { cursor: "pointer" } : {}
              }
            >
              <input
                id="radioPessoaJuridica"
                type="radio"
                className="custom-radio"
                value="juridica"
                checked={tipoPessoa === "juridica"}
                style={
                  acaoFornecedor === "CADASTRAR" ? { cursor: "pointer" } : {}
                }
                disabled={acaoFornecedor !== "CADASTRAR"}
              />
              <label
                htmlFor="radioPessoaJuridica"
                style={
                  acaoFornecedor === "CADASTRAR" ? { cursor: "pointer" } : {}
                }
              >
                Pessoa jurídica
              </label>
            </span>

            <span
              onClick={
                acaoFornecedor === "CADASTRAR"
                  ? () => handleCheck("fisica")
                  : () => {}
              }
              style={
                acaoFornecedor === "CADASTRAR" ? { cursor: "pointer" } : {}
              }
            >
              <input
                id="radioPessoaFisica"
                type="radio"
                className="custom-radio"
                value="fisica"
                checked={tipoPessoa === "fisica"}
                style={
                  acaoFornecedor === "CADASTRAR" ? { cursor: "pointer" } : {}
                }
                disabled={acaoFornecedor !== "CADASTRAR"}
              />
              <label
                htmlFor="radioPessoaFisica"
                style={
                  acaoFornecedor === "CADASTRAR" ? { cursor: "pointer" } : {}
                }
              >
                Pessoa física
              </label>
            </span>
          </RadioContainer>
          {tipoPessoa === "juridica" ? (
            <>
              <Row style={{ marginBottom: "24px" }}>
                <Col>
                  <Form.Group>
                    <Form.Label>
                      CNPJ <Required />
                    </Form.Label>
                    <CustomInput
                      type="text"
                      {...register("cpfCnpj")}
                      style={{
                        borderRadius: "5px",
                        boxShadow: "none",
                        borderColor: "#CED4DA",
                        height: "2.2rem",
                      }}
                      placeholder="Digite o CNPJ"
                      disabled={acaoFornecedor !== "CADASTRAR"}
                      isInvalid={!!errors.cpfCnpj}
                      mensagemErro={errors.cpfCnpj?.message}
                      onChange={(element) => {
                        mInputCNPJ(element);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>
                      Razão social <Required />
                    </Form.Label>
                    <CustomInput
                      type="text"
                      {...register("nomeRazaoSocial")}
                      placeholder="Digite a razão social"
                      disabled={acaoFornecedor !== "CADASTRAR"}
                      isInvalid={!!errors.nomeRazaoSocial}
                      mensagemErro={errors.nomeRazaoSocial?.message}
                      style={{
                        borderRadius: "5px",
                        boxShadow: "none",
                        borderColor: "#CED4DA",
                        height: "2.2rem",
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>
                      Nome fantasia <Required />
                    </Form.Label>
                    <CustomInput
                      type="text"
                      {...register("nomeFantasia")}
                      style={{
                        borderRadius: "5px",
                        boxShadow: "none",
                        borderColor: "#CED4DA",
                        height: "2.2rem",
                      }}
                      placeholder="Digite o nome fantasia"
                      disabled={acaoFornecedor === "VER"}
                      isInvalid={!!errors.nomeFantasia}
                      mensagemErro={errors.nomeFantasia?.message}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {fields.map((item: any, index) => (
                <Row
                  key={item.id}
                  style={
                    index === fields.length - 1 && acaoFornecedor === "VER"
                      ? {}
                      : { marginBottom: "24px" }
                  }
                >
                  <Col>
                    <Form.Group>
                      <Form.Label>
                        Nome do responsável <Required />
                      </Form.Label>
                      <CustomInput
                        type="text"
                        {...register(`responsaveis.${index}.nomeResponsavel`)}
                        defaultValue={item.nomeResponsavel}
                        placeholder="Digite o nome do responsável"
                        disabled={acaoFornecedor === "VER"}
                        isInvalid={
                          !!(errors.responsaveis as any)?.[index]
                            ?.nomeResponsavel
                        }
                        mensagemErro={
                          (errors.responsaveis as any)?.[index]?.nomeResponsavel
                            ?.message
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>
                        Telefone <Required />
                      </Form.Label>
                      <CustomInput
                        type="text"
                        {...register(`responsaveis.${index}.telefone`)}
                        defaultValue={item.telefone}
                        placeholder="Digite o telefone"
                        disabled={acaoFornecedor === "VER"}
                        isInvalid={
                          !!(errors.responsaveis as any)?.[index]?.telefone
                        }
                        mensagemErro={
                          (errors.responsaveis as any)?.[index]?.telefone
                            ?.message
                        }
                        onChange={(e) => {
                          e.target.value = mInputTel(e);
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Label>
                        E-mail <Required />
                      </Form.Label>
                      <CustomInput
                        type="text"
                        {...register(`responsaveis.${index}.email`)}
                        defaultValue={item.email}
                        placeholder="Digite o e-mail"
                        disabled={acaoFornecedor === "VER"}
                        isInvalid={
                          !!(errors.responsaveis as any)?.[index]?.email
                        }
                        mensagemErro={
                          (errors.responsaveis as any)?.[index]?.email?.message
                        }
                        iconeDireitoExterno={
                          acaoFornecedor !== "VER" && index > 0 ? (
                            <span
                              style={{
                                paddingTop: "10px",
                                marginLeft: "10px",
                              }}
                            >
                              <FaTimes
                                style={{ color: "red", cursor: "pointer" }}
                                onClick={() => remove(index)}
                              />
                            </span>
                          ) : undefined
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
              ))}

              {acaoFornecedor !== "VER" && (
                <div>
                  <span
                    style={{ cursor: "pointer", fontWeight: 600 }}
                    onClick={novoCampo}
                  >
                    <IconeAdicionar>
                      <FaPlus />
                    </IconeAdicionar>{" "}
                    Adicionar responsável
                  </span>
                </div>
              )}
            </>
          ) : (
            <>
              <Row style={{ marginBottom: "24px" }}>
                <Col>
                  <Form.Group>
                    <Form.Label>
                      CPF <Required />
                    </Form.Label>
                    <CustomInput
                      type="text"
                      {...register("cpfCnpj")}
                      style={{
                        borderRadius: "5px",
                        boxShadow: "none",
                        borderColor: "#CED4DA",
                        height: "2.2rem",
                      }}
                      placeholder="Informe o CPF"
                      disabled={acaoFornecedor !== "CADASTRAR"}
                      isInvalid={!!errors.cpfCnpj}
                      mensagemErro={errors.cpfCnpj?.message}
                      onChange={(element) => {
                        mInputCPF(element);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>
                      Nome completo <Required />
                    </Form.Label>
                    <CustomInput
                      type="text"
                      {...register("nomeRazaoSocial")}
                      style={{
                        borderRadius: "5px",
                        boxShadow: "none",
                        borderColor: "#CED4DA",
                        height: "2.2rem",
                      }}
                      placeholder="Informe o nome completo"
                      disabled={acaoFornecedor !== "CADASTRAR"}
                      isInvalid={!!errors.nomeRazaoSocial}
                      mensagemErro={errors.nomeRazaoSocial?.message}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group>
                    <Form.Label>
                      Telefone <Required />
                    </Form.Label>
                    <CustomInput
                      type="text"
                      {...register("telefone")}
                      style={{
                        borderRadius: "5px",
                        boxShadow: "none",
                        borderColor: "#CED4DA",
                        height: "2.2rem",
                      }}
                      placeholder="Informe o telefone"
                      disabled={acaoFornecedor === "VER"}
                      isInvalid={!!errors.telefone}
                      mensagemErro={errors.telefone?.message}
                      onChange={(element) => {
                        mInputTel(element);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group>
                    <Form.Label>
                      E-mail <Required />
                    </Form.Label>
                    <CustomInput
                      type="text"
                      {...register("email")}
                      style={{
                        borderRadius: "5px",
                        boxShadow: "none",
                        borderColor: "#CED4DA",
                        height: "2.2rem",
                      }}
                      placeholder="Informe o e-mail"
                      disabled={acaoFornecedor === "VER"}
                      isInvalid={!!errors.email}
                      mensagemErro={errors.email?.message}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </ContainerCinza>
        <ContainerCinza>
          <ContainerTitle>
            <Title>Endereço</Title>
          </ContainerTitle>
          <Row style={{ marginBottom: "24px" }}>
            <Col md={2}>
              <Form.Group>
                <Form.Label>
                  CEP <Required />
                </Form.Label>
                <CustomInput
                  type="text"
                  {...register("cep")}
                  style={{
                    borderRadius: "5px",
                    boxShadow: "none",
                    borderColor: "#CED4DA",
                    height: "2.2rem",
                  }}
                  placeholder="Digite o CEP"
                  disabled={acaoFornecedor === "VER"}
                  isInvalid={!!errors.cep}
                  mensagemErro={errors.cep?.message}
                  onChange={onChangeCep}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>
                  Endereço <Required />
                </Form.Label>
                <CustomInput
                  type="text"
                  {...register("endereco")}
                  style={{
                    borderRadius: "5px",
                    boxShadow: "none",
                    borderColor: "#CED4DA",
                    height: "2.2rem",
                  }}
                  placeholder="Digite o endereço"
                  disabled={acaoFornecedor === "VER"}
                  isInvalid={!!errors.endereco}
                  mensagemErro={errors.endereco?.message}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>
                  Número <Required />
                </Form.Label>
                <CustomInput
                  type="text"
                  {...register("numero")}
                  style={{
                    borderRadius: "5px",
                    boxShadow: "none",
                    borderColor: "#CED4DA",
                    height: "2.2rem",
                  }}
                  placeholder="Digite o número"
                  disabled={acaoFornecedor === "VER"}
                  isInvalid={!!errors.numero}
                  mensagemErro={errors.numero?.message}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Complemento</Form.Label>
                <CustomInput
                  type="text"
                  {...register("complemento")}
                  style={{
                    borderRadius: "5px",
                    boxShadow: "none",
                    borderColor: "#CED4DA",
                    height: "2.2rem",
                  }}
                  placeholder="Digite o complemento"
                  disabled={acaoFornecedor === "VER"}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>
                  Bairro <Required />
                </Form.Label>
                <CustomInput
                  type="text"
                  {...register("bairro")}
                  style={{
                    borderRadius: "5px",
                    boxShadow: "none",
                    borderColor: "#CED4DA",
                    height: "2.2rem",
                  }}
                  placeholder="Digite o bairro"
                  disabled={acaoFornecedor === "VER"}
                  isInvalid={!!errors.bairro}
                  mensagemErro={errors.bairro?.message}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>
                  Cidade <Required />
                </Form.Label>
                <CustomInput
                  type="text"
                  {...register("cidade")}
                  style={{
                    borderRadius: "5px",
                    boxShadow: "none",
                    borderColor: "#CED4DA",
                    height: "2.2rem",
                  }}
                  placeholder="Digite a cidade"
                  disabled={acaoFornecedor === "VER"}
                  isInvalid={!!errors.cidade}
                  mensagemErro={errors.cidade?.message}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>
                  Estado <Required />
                </Form.Label>
                <Controller
                  control={control}
                  name="uf"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={[
                        { value: "AC", label: "Acre" },
                        { value: "AL", label: "Alagoas" },
                        { value: "AM", label: "Amazonas" },
                        { value: "AP", label: "Amapá" },
                        { value: "BA", label: "Bahia" },
                        { value: "CE", label: "Ceará" },
                        { value: "DF", label: "Distrito Federal" },
                        { value: "ES", label: "Espírito Santo" },
                        { value: "GO", label: "Goiás" },
                        { value: "MA", label: "Maranhão" },
                        { value: "MT", label: "Mato Grosso" },
                        { value: "MS", label: "Mato Grosso do Sul" },
                        { value: "MG", label: "Minas Gerais" },
                        { value: "PA", label: "Pará" },
                        { value: "PB", label: "Paraíba" },
                        { value: "PR", label: "Paraná" },
                        { value: "PE", label: "Pernambuco" },
                        { value: "PI", label: "Piauí" },
                        { value: "RJ", label: "Rio de Janeiro" },
                        { value: "RN", label: "Rio Grande do Norte" },
                        { value: "RS", label: "Rio Grande do Sul" },
                        { value: "RO", label: "Rondônia" },
                        { value: "RR", label: "Roraima" },
                        { value: "SC", label: "Santa Catarina" },
                        { value: "SP", label: "São Paulo" },
                        { value: "SE", label: "Sergipe" },
                        { value: "TO", label: "Tocantins" },
                      ]}
                      title=""
                      selectedValue={value}
                      onSelect={onChange}
                      searchable
                      semBorda
                      disabled={acaoFornecedor === "VER"}
                      mensagemErro={
                        errors.uf?.message ? `${errors.uf?.message}` : null
                      }
                      exibirValorDesabilitado
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
        </ContainerCinza>
        <ContainerCinza>
          <ContainerTitle>
            <Title>Dados bancários</Title>
          </ContainerTitle>
          <div style={{ marginBottom: "24px" }}>
            Selecione as formas de recebimento do fornecedor.
          </div>
          <InputCheckboxContainer>
            <input
              onChange={(e) => handleCheckBoleto(e.target.checked)}
              type="checkbox"
              name="checkboxBoleto"
              id="checkboxBoleto"
              checked={boletoChecked}
              disabled={acaoFornecedor === "VER"}
            />
            <label
              style={{
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "100%",
                letterSpacing: "0%",
              }}
              htmlFor="checkboxBoleto"
            >
              Boleto
            </label>
          </InputCheckboxContainer>
          <InputCheckboxContainer>
            <input
              onChange={(e) => handleCheckPix(e.target.checked)}
              type="checkbox"
              name="checkboxPix"
              id="checkboxPix"
              checked={showDadosPix}
              disabled={acaoFornecedor === "VER"}
            />
            <label
              style={{
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "100%",
                letterSpacing: "0%",
              }}
              htmlFor="checkboxPix"
            >
              Pix
            </label>
          </InputCheckboxContainer>
          <Row
            className={`${!showDadosPix && "d-none"}`}
            style={{ marginBottom: "24px" }}
          >
            <Col>
              <Form.Group>
                <Form.Label>
                  Chave Pix <Required />
                </Form.Label>
                <CustomInput
                  type="text"
                  {...register("chavePix")}
                  style={{
                    borderRadius: "5px",
                    boxShadow: "none",
                    borderColor: "#CED4DA",
                    height: "2.2rem",
                  }}
                  placeholder="Digite a chave PIX"
                  iconeDireito={
                    dados && dados?.chavePix ? (
                      <FaCopy title="Copiar chave" />
                    ) : null
                  }
                  onClickMostrarSenha={onClickCopiarString}
                  disabled={acaoFornecedor === "VER"}
                  isInvalid={!!errors.chavePix}
                  mensagemErro={errors.chavePix?.message}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>
                  Titular da conta <Required />
                </Form.Label>
                <CustomInput
                  type="text"
                  {...register("titularContaPix")}
                  style={{
                    borderRadius: "5px",
                    boxShadow: "none",
                    borderColor: "#CED4DA",
                    height: "2.2rem",
                  }}
                  placeholder="Digite o titular da conta"
                  disabled={acaoFornecedor === "VER"}
                  isInvalid={!!errors.titularContaPix}
                  mensagemErro={errors.titularContaPix?.message}
                />
              </Form.Group>
            </Col>
          </Row>
          <InputCheckboxContainer>
            <input
              onChange={(e) => handleCheckTransferencia(e.target.checked)}
              type="checkbox"
              name="checkboxTransferencia"
              id="checkboxTransferencia"
              checked={showDadosTransferencia}
              disabled={acaoFornecedor === "VER"}
            />
            <label
              style={{
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "100%",
                letterSpacing: "0%",
              }}
              htmlFor="checkboxTransferencia"
            >
              Transferencia
            </label>
          </InputCheckboxContainer>
          <div className={`${!showDadosTransferencia && "d-none"}`}>
            <Row style={{ marginBottom: "24px" }}>
              <Col>
                <Form.Group>
                  <Form.Label>
                    Banco <Required />
                  </Form.Label>
                  <Controller
                    control={control}
                    name="banco"
                    render={({ field: { onChange, value } }) => (
                      <DropdownSelect
                        options={OptionsBancos}
                        title=""
                        selectedValue={value}
                        onSelect={(valor: any) => onChange(valor)}
                        searchable
                        semBorda
                        disabled={acaoFornecedor === "VER"}
                        mensagemErro={
                          errors.banco?.message
                            ? `${errors.banco?.message}`
                            : null
                        }
                        exibirValorDesabilitado
                      />
                    )}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>
                    Agência <Required />
                  </Form.Label>
                  <CustomInput
                    type="text"
                    {...register("agencia")}
                    style={{
                      borderRadius: "5px",
                      boxShadow: "none",
                      borderColor: "#CED4DA",
                      height: "2.2rem",
                    }}
                    placeholder="Digite a agência"
                    disabled={acaoFornecedor === "VER"}
                    isInvalid={!!errors.agencia}
                    mensagemErro={errors.agencia?.message}
                    onChange={(element) => {
                      mInputNum(element);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>
                    Conta <Required />
                  </Form.Label>
                  <CustomInput
                    type="text"
                    {...register("conta")}
                    style={{
                      borderRadius: "5px",
                      boxShadow: "none",
                      borderColor: "#CED4DA",
                      height: "2.2rem",
                    }}
                    placeholder="Digite o número da conta"
                    disabled={acaoFornecedor === "VER"}
                    isInvalid={!!errors.conta}
                    mensagemErro={errors.conta?.message}
                    onChange={(element) => {
                      mInputNum(element);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>
                    Titular da conta <Required />
                  </Form.Label>
                  <CustomInput
                    type="text"
                    {...register("titularContaTransferencia")}
                    style={{
                      borderRadius: "5px",
                      boxShadow: "none",
                      borderColor: "#CED4DA",
                      height: "2.2rem",
                    }}
                    placeholder="Digite o nome do titular"
                    disabled={acaoFornecedor === "VER"}
                    isInvalid={!!errors.titularContaTransferencia}
                    mensagemErro={errors.titularContaTransferencia?.message}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>
                    CPF/CNPJ Titular <Required />
                  </Form.Label>
                  <CustomInput
                    type="text"
                    {...register("cpfCnpjTitularContaTransferencia")}
                    style={{
                      borderRadius: "5px",
                      boxShadow: "none",
                      borderColor: "#CED4DA",
                      height: "2.2rem",
                    }}
                    placeholder="Digite o CPF ou CNPJ do titular"
                    disabled={acaoFornecedor === "VER"}
                    isInvalid={!!errors.cpfCnpjTitularContaTransferencia}
                    mensagemErro={
                      errors.cpfCnpjTitularContaTransferencia?.message
                    }
                    onChange={(element) => {
                      mInputCPFCNPJ(element);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>
        </ContainerCinza>
        <ContainerCinza>
          <ContainerTitle>
            <Title>Descrição processo financeiro</Title>
          </ContainerTitle>
          <ContainerFormProcessoFinanceiro>
            <Row>
              <Col>
                <TituloCampoProcessoFinanceiro>
                  Processo financeiro <Required />
                </TituloCampoProcessoFinanceiro>
                <DropdownSelect
                  options={optionsDescricaoProcessoFinanceiro}
                  title=""
                  selectedValue={descricaoProcessoFinanceiroEscolhido}
                  onSelect={(id) => {
                    setDescricaoProcessoFinanceiroEscolhido(id);
                  }}
                  searchable
                  disabled={acaoFornecedor === "VER"}
                />
              </Col>
              <Col>
                <TituloCampoProcessoFinanceiro>
                  Valor por processo <Required />
                </TituloCampoProcessoFinanceiro>
                <CustomInput
                  type="text"
                  style={{
                    borderRadius: "5px",
                    boxShadow: "none",
                    borderColor: "#CED4DA",
                    height: "2.2rem",
                  }}
                  placeholder="R$ 0.00"
                  title=""
                  value={valorProcessoFinanceiroEscolhido ?? ""}
                  onChange={(e) => {
                    setValorProcessoFinanceiroEscolhido(mInputCoin(e));
                  }}
                  disabled={acaoFornecedor === "VER"}
                />
              </Col>
              <Col md={2} style={{ paddingTop: "28px" }}>
                <ContainerBtnFormProcessoFinanceiro>
                  <Button
                    type="button"
                    disabled={
                      !descricaoProcessoFinanceiroEscolhido ||
                      !valorProcessoFinanceiroEscolhido ||
                      valorProcessoFinanceiroEscolhido <= 0 ||
                      acaoFornecedor === "VER"
                    }
                    onClick={
                      acaoFormProcessoFinanceiro === "Adicionar"
                        ? handleConfirmAdicionarFinanceiro
                        : handleConfirmEditarFinanceiro
                    }
                  >
                    {acaoFormProcessoFinanceiro}
                  </Button>
                  <Button
                    type="button"
                    outline
                    variante="primary"
                    disabled={
                      (!descricaoProcessoFinanceiroEscolhido &&
                        !valorProcessoFinanceiroEscolhido) ||
                      acaoFornecedor === "VER"
                    }
                    onClick={handleLimparFormProcessoFinanceiro}
                  >
                    Limpar
                  </Button>
                </ContainerBtnFormProcessoFinanceiro>
              </Col>
            </Row>
          </ContainerFormProcessoFinanceiro>
          {!!dadosTabelaProcessoFinanceiro.length && (
            <Table
              keyField="id"
              data={dadosTabelaProcessoFinanceiro}
              columns={columnsProcessoFinanceiro}
              loading={false}
              noSubHeader
              customTableStyle={{
                table: {
                  style: {
                    border: "1px solid #B9B9B9",
                  },
                },
              }}
            />
          )}
        </ContainerCinza>
        <ContainerBtnSubmit>
          {acaoFornecedor === "VER" && (
            <>
              <Button
                type="button"
                variante="primary"
                outline
                onClick={handleVoltarListagem}
              >
                <FaArrowLeft /> Voltar
              </Button>
              {showBtnEditar && (
                <Button
                  type="button"
                  onClick={() => {
                    setAcaoFornecedor("ATUALIZAR");
                  }}
                >
                  <FaPen /> Editar
                </Button>
              )}
            </>
          )}
          {acaoFornecedor === "ATUALIZAR" && (
            <>
              <Button
                type="button"
                variante="primary"
                outline
                onClick={() => {
                  setShowModalCancelarEditar(true);
                }}
              >
                Cancelar
              </Button>
              <Button type="submit">
                <FaCheck /> Salvar
              </Button>
            </>
          )}
          {acaoFornecedor === "CADASTRAR" && (
            <>
              <Button variante="primary" outline onClick={handleVoltarListagem}>
                Cancelar
              </Button>
              <Button type="submit">Cadastrar</Button>
            </>
          )}
        </ContainerBtnSubmit>
      </Form>
      <ModalConfirmarExcluirProcessoFinanceiro
        show={showModalConfirmarExclusao}
        handleClose={() => {
          setShowModalConfirmarExclusao(false);
          setIdDescricaoProcessoFinanceiroExcluir(0);
        }}
        onSubmit={handleConfirmExcluirFinanceiro}
      />
      <ModalConfirmarEditarFornecedor
        show={showModalConfirmarEditar}
        handleClose={() => {
          setShowModalConfirmarEditar(false);
          setDadosEditarFornecedor(null);
        }}
        onSubmit={confirmarEditarFornecedor}
      />
      <ModalConfirmarCancelarEditarFornecedor
        show={showModalCancelarEditar}
        handleClose={() => {
          setShowModalCancelarEditar(false);
        }}
        onSubmit={handleVoltarListagem}
      />
    </>
  );
}
